import cn from 'classnames';

interface LessonChipProps {
  order: number;
  state: 'completed' | 'current' | 'upcoming';
}

export const LessonChip = ({ order, state }: LessonChipProps) => (
  <div
    className={cn(
      'h-9 w-9 rounded-md border text-sm font-medium flex items-center justify-center select-none',
      {
        ['bg-[#211D55] text-white']: state === 'completed',
        ['bg-white text-black border-[#211D55]']: state === 'current',
        ['bg-neutral-hover text-grey border-transparent']: state === 'upcoming',
      },
    )}
    aria-current={state === 'current' ? 'step' : undefined}
  >
    {order}
  </div>
);
